import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import jsPDF from "jspdf";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL, UPLOADS_BASE_URL } from '../../../config.js'
import { APP_BASE_URL } from '../../../config.js'
import Select from "react-select";
import DataTable, { defaultThemes } from 'react-data-table-component';
// import Select from 'react-select';


import { Accordion } from 'react-bootstrap-accordion'
import 'react-bootstrap-accordion/dist/index.css'

import RecruitmentDetails from '../Employee/RecruitmentDetails.js';

import EmpVerification from '../Employee/EmployeeVerificationControl.js';
import TraingingAccomodation from '../Employee/TrainingAndAccomodation.js';
import '../../../../src/AccordionScroll.css';






import {
	statisticsAction,
	statisticsCloseAction
} from '../../../actions/settingsAction';
import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min.js';
import { useParams } from "react-router-dom";
import { useFormStatus } from 'react-dom';
const EmployeeDetailControl = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;

	const [offerLetterData, setOfferLetterData] = useState(null);
const fetchOfferLetterData = async () => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/offer-letter/${users.user_id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      }
    );

    if (res.data.status === 200) {
      setOfferLetterData(res.data.data); // ✅ store data
    } else {
      toast.error("Offer letter data not found");
    }
  } catch (error) {
    toast.error("Failed to load offer letter data");
  }
};



const getTitle = (gender, maritalStatus) => {
  if (!gender) return "";

  if (gender === "Male") {
    return "Mr.";
  }

  if (gender === "Female") {
    if (maritalStatus && maritalStatus.toLowerCase() === "single") {
      return "Ms.";
    }
    return "Mrs.";
  }

  return "";
};


const generateOfferLetter = () => {
  const doc = new jsPDF("p", "mm", "a4");

  const LEFT = 16;
  const RIGHT = 194;
  const CENTER = 105;
  const MAX_W = 178;
  const SIZE = 11;
  const LINE = 5;
  const GAP = 5;

  let y = 63; // top space kept blank for the printed letterhead

  const designationName =
    designationDropdownOptions.find(d => d.designation_id == designation)
      ?.designation_name || "";

  const title = getTitle(users.gender, users.marital_status);

  // split styled segments into words and the whitespace between them so a
  // paragraph can mix normal and bold runs and still wrap on the column
  const tokenize = (segments) => {
    const tokens = [];
    segments.forEach(({ text, font = "normal" }) => {
      String(text).split(/(\s+)/).forEach((piece) => {
        if (piece === "") return;
        tokens.push({ text: piece, font, space: /^\s+$/.test(piece) });
      });
    });
    return tokens;
  };

  const richPara = (segments, opts = {}) => {
    const { x = LEFT, width = MAX_W, gap = GAP } = opts;

    doc.setFontSize(SIZE);

    let line = [];
    let lineW = 0;

    const flush = () => {
      // draw consecutive same-font tokens as one string so the font keeps its
      // own kerning instead of every word being placed at a measured offset
      const runs = [];
      line.forEach((token) => {
        const last = runs[runs.length - 1];
        if (last && last.font === token.font) last.text += token.text;
        else runs.push({ text: token.text, font: token.font });
      });

      let cx = x;
      runs.forEach((run) => {
        doc.setFont("times", run.font);
        doc.text(run.text, cx, y);
        cx += doc.getTextWidth(run.text);
      });

      y += LINE;
      line = [];
      lineW = 0;
    };

    tokenize(segments).forEach((token) => {
      doc.setFont("times", token.font);
      const w = doc.getTextWidth(token.text);

      if (lineW + w > width && line.length) {
        flush();
        if (token.space) return; // drop the space that caused the wrap
      }

      line.push(token);
      lineW += w;
    });

    if (line.length) flush();
    y += gap;
  };

  const bullet = (text) => {
    doc.setFont("times", "normal");
    doc.setFontSize(SIZE);
    doc.text("•", LEFT + 6, y);
    richPara([{ text }], { x: LEFT + 11, width: MAX_W - 11, gap: 0 });
  };

  const boldLine = (text, opts = {}) => {
    const { x = LEFT, align = "left", gap = 10 } = opts;
    doc.setFont("times", "bold");
    doc.setFontSize(SIZE);
    doc.text(text, x, y, align === "left" ? undefined : { align });
    y += gap;
  };

  // ===== DATE (right aligned) =====
  boldLine(
    `Date: ${new Date().toLocaleDateString("en-GB").replace(/\//g, "-")}`,
    { x: RIGHT, align: "right" }
  );

  // ===== SALUTATION =====
  boldLine(`Dear ${title} ${users.first_name} ${users.last_name},`);

  // ===== OFFER HEADING (centered + underlined) =====
  const heading = "Offer for Employment";
  doc.setFont("times", "bold");
  doc.setFontSize(SIZE);
  doc.text(heading, CENTER, y, { align: "center" });
  const headingW = doc.getTextWidth(heading);
  doc.setLineWidth(0.4);
  doc.line(CENTER - headingW / 2, y + 1.2, CENTER + headingW / 2, y + 1.2);
  y += 10;

  // ===== CONTENT =====
  richPara([{ text: "Greetings from Annai Arul Public School," }]);

  richPara([
    { text: "We are pleased to offer you employment in our organization as " },
    { text: designationName, font: "bold" },
    { text: " on the following terms and conditions." },
  ]);

  richPara([{ text: "You will be under probation for 6 months." }]);

  // the offer letter must show the very first salary that was added for this
  // employee, not whatever the current one happens to be
  const offerCtc = firstSalary ? firstSalary.ctc : ctc;
  const ctcAmount = Number(offerCtc || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  richPara([
    { text: "Monthly Cost to the Company is " },
    { text: `Rs. ${ctcAmount} /-`, font: "bold" },
    {
      text:
        ` (Rupees ${numberToWordsIndian(offerCtc)} only). You may also be eligible for other ` +
        "compensation and fringe benefits subject to the terms set by Annai Arul Public School, " +
        "which may be amended from time to time.",
    },
  ]);

  // ===== CONDITIONS =====
  richPara([{ text: "Your employment is subject to:" }]);

  bullet("Proof of your educational certificates.");
  bullet("Proof of your address.");
  bullet(
    "You have to fill Joining form, Applicant Profile form, PF Nomination form, etc. " +
      "Arrange to submit it on or before your joining."
  );
  y += GAP;

  // ===== NOTE =====
  richPara([
    {
      text:
        "Please note that this is only a provisional offer for employment and is not to be " +
        "construed as an appointment letter.",
    },
  ]);

  richPara([
    {
      text:
        "The representations contained in this offer letter and enclosures surpass all prior " +
        "written or oral presentations or communications pertaining to Annai Arul Public " +
        "School’s offer of Employment.",
    },
  ]);

  richPara([
    {
      text:
        "Kindly sign the duplicate copy of this letter as a token of your acceptance of the " +
        "provisional offer. A detailed appointment letter will be sent to you once you fulfill " +
        "our employment conditions.",
    },
  ]);

  // ===== CLOSING =====
  boldLine("Wishing you the very best!", { gap: 17 });

  boldLine("Sincerely,", { gap: 9.5 });
  boldLine("For Annai Arul Public School", { gap: 9.5 });
  boldLine("(Dean)", { x: RIGHT, align: "right", gap: 22 });

  // ===== ACCEPTANCE =====
  boldLine("I have read and accept the above terms and conditions of employment.", {
    gap: 9.5,
  });
  boldLine("Date: ___________________________", { gap: 0 });

  // ===== SAVE =====
  doc.save(`Offer_Letter_${users.employee_id}.pdf`);
};


// ===== Amount in words (Indian format with "and") =====
const numberToWordsIndian = (num) => {
  if (!num) return "";

  const a = [
    "", "One", "Two", "Three", "Four", "Five", "Six",
    "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
    "Thirteen", "Fourteen", "Fifteen", "Sixteen",
    "Seventeen", "Eighteen", "Nineteen"
  ];

  const b = [
    "", "", "Twenty", "Thirty", "Forty",
    "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
  ];

  const twoDigit = (n) =>
    n < 20 ? a[n] : b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");

  const inWords = (n) => {
    if (n < 100) return twoDigit(n);
    if (n < 1000)
      return a[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " and " + twoDigit(n % 100) : "");
    if (n < 100000)
      return twoDigit(Math.floor(n / 1000)) + " Thousand" + (n % 1000 ? " " + inWords(n % 1000) : "");
    if (n < 10000000)
      return twoDigit(Math.floor(n / 100000)) + " Lakh" + (n % 100000 ? " " + inWords(n % 100000) : "");
    return "";
  };

  return inWords(Math.round(Number(num)));
};


const generateAppointmentOrder = () => {
  const doc = new jsPDF("p", "mm", "a4");

  const LEFT = 15;
  const CENTER = 105;
  const MAX_W = 180;
  const SIZE = 12;
  const LINE = 6.14;
  const PARA_GAP = 6.14;
  // blank space kept at the top of every sheet for the printed letterhead
  const LETTERHEAD_TOP = 57.6;
  const BOTTOM = 262; // blank space kept at the foot of every sheet

  let y = LETTERHEAD_TOP;

  // ===== Helpers =====
  const formatDate = (date) => {
    const d = new Date(date);
    if (isNaN(d.getTime())) return "";

    return [
      String(d.getDate()).padStart(2, "0"),
      String(d.getMonth() + 1).padStart(2, "0"),
      d.getFullYear(),
    ].join("-");
  };

  const formatAmount = (val) => Number(val || 0).toLocaleString("en-IN");

  // the salary fitment table prints plain figures, without grouping
  const plainAmount = (val) => String(Number(val || 0));

  // split styled segments into words and the whitespace between them so a
  // paragraph can mix normal and bold runs and still wrap on the column
  const tokenize = (segments) => {
    const tokens = [];
    segments.forEach(({ text, font = "normal" }) => {
      String(text).split(/(\s+)/).forEach((piece) => {
        if (piece === "") return;
        tokens.push({ text: piece, font, space: /^\s+$/.test(piece) });
      });
    });
    return tokens;
  };

  // draw consecutive same-font tokens as one string so the font keeps its own
  // kerning instead of every word being placed at a measured offset
  const drawLine = (tokens, x, align) => {
    const runs = [];
    tokens.forEach((token) => {
      const last = runs[runs.length - 1];
      if (last && last.font === token.font) last.text += token.text;
      else runs.push({ text: token.text, font: token.font });
    });

    let cx = x;

    if (align === "center") {
      let total = 0;
      runs.forEach((run) => {
        doc.setFont("times", run.font);
        total += doc.getTextWidth(run.text);
      });
      cx = CENTER - total / 2;
    }

    runs.forEach((run) => {
      doc.setFont("times", run.font);
      doc.text(run.text, cx, y);
      cx += doc.getTextWidth(run.text);
    });
  };

  const richPara = (segments, opts = {}) => {
    const { x = LEFT, width = MAX_W, gap = PARA_GAP, align = "left" } = opts;

    doc.setFontSize(SIZE);

    let line = [];
    let lineW = 0;

    // flow line by line so a paragraph continues on the next sheet instead of
    // leaving a large blank block behind
    const flush = () => {
      if (y > BOTTOM) {
        doc.addPage();
        y = LETTERHEAD_TOP;
        doc.setFontSize(SIZE);
      }

      drawLine(line, x, align);
      y += LINE;
      line = [];
      lineW = 0;
    };

    tokenize(segments).forEach((token) => {
      doc.setFont("times", token.font);
      const w = doc.getTextWidth(token.text);

      if (lineW + w > width && line.length) {
        flush();
        if (token.space) return; // drop the space that caused the wrap
      }

      line.push(token);
      lineW += w;
    });

    if (line.length) flush();
    y += gap;
  };

  // ===== Employee data =====
  const title = getTitle(users.gender, users.marital_status);

  const employeeName = `${users.first_name || ""} ${users.last_name || ""}`.trim();

  const designationName =
    designationDropdownOptions.find((d) => d.designation_id == designation)
      ?.designation_name || "";

  const probationNotice = 15;

  // ===== Salary at the time of appointment =====
  // the appointment order must always show the very first salary that was
  // added for this employee, not whatever the current one happens to be
  const sal = {
    basic: firstSalary ? firstSalary.basic_sal : basic_salary,
    hra: firstSalary ? firstSalary.hra : hra,
    convy: firstSalary ? firstSalary.convyance : convy,
    wash_allow: firstSalary ? firstSalary.wash_allowance : wash_allow,
    special_convyance: firstSalary
      ? firstSalary.special_convyance
      : special_convyance,
    gross: firstSalary ? firstSalary.gross_salary : gross_salary,
    pf_employer: firstSalary ? firstSalary.pe_employer : pf_employer,
    esi_employer: firstSalary ? firstSalary.esi_employer : esi_employer,
    insurance: firstSalary ? firstSalary.insurance : insurance,
    ctc: firstSalary ? firstSalary.ctc : ctc,
    pf_employee: firstSalary ? firstSalary.pf_employee : pf_employee,
    esi_employee: firstSalary ? firstSalary.esi_employee : esi_employee,
    pt: firstSalary ? firstSalary.pt : pt,
    net_take: firstSalary ? firstSalary.net_take : net_take,
  };

  // ===== DATE (right aligned) — the employee's date of joining =====
  doc.setFont("times", "bold");
  doc.setFontSize(SIZE);
  doc.text(formatDate(users.date_of_joining || new Date()), 193, y, {
    align: "right",
  });

  y += 12.3;

  // ===== ADDRESS BLOCK =====
  doc.setFont("times", "bold");
  doc.text(`${title} ${employeeName}`.trim(), LEFT, y);
  y += LINE;

  if (users.address) {
    // one address segment per line, the way the printed letter is addressed
    doc.setFont("times", "normal");

    String(users.address)
      .split(/\r?\n|,/)
      .map((part) => part.trim())
      .filter(Boolean)
      .forEach((part) => {
        doc.splitTextToSize(part, MAX_W).forEach((l) => {
          doc.text(l, LEFT, y);
          y += LINE;
        });
      });
  }

  y += 7;

  // ===== HEADING =====
  doc.setFont("times", "bold");
  doc.setFontSize(14);
  doc.text("Appointment Order", CENTER, y, { align: "center" });
  const headingW = doc.getTextWidth("Appointment Order");
  doc.setLineWidth(0.4);
  doc.line(CENTER - headingW / 2, y + 1.5, CENTER + headingW / 2, y + 1.5);

  y += 12.5;

  // ===== SALUTATION =====
  richPara([{ text: `Dear ${employeeName},`, font: "bold" }]);

  // ===== INTRO =====
  richPara([
    {
      text:
        "Congratulations! Further to your application for employment for a suitable position with " +
        "Annai Arul Public School hereinafter referred to as “AAPS”, and the subsequent " +
        `selection process, we are delighted to offer you a position as ${designationName}. You are ` +
        "requested to join us on terms and conditions of appointment as applicable in the school.",
    },
  ]);

  richPara([
    { text: "Your emolument by the way of Monthly Cost to the Company is " },
    { text: `Rs. ${formatAmount(sal.ctc)} /-`, font: "bold" },
    {
      text:
        ` per month (Rupees ${numberToWordsIndian(sal.ctc)} only). The details of which are ` +
        "given in the annexure of the appointment letter.",
    },
  ]);

  richPara([
    { text: "The terms and conditions of employment are as follows:", font: "bold" },
  ]);

  // ===== 1. TENURE PERIOD =====
  richPara([{ text: "1. Tenure Period", font: "bold" }], { gap: 0 });
  richPara([
    {
      text:
        "You will be on Tenure for six months, which may be extended by the management at its " +
        "discretion. At the end of the probation period your services with the school would be " +
        "confirmed subject to your performance meeting the requisite standards. Until issued a " +
        "Confirmation Letter you shall continue to be on probation. During the probation period, " +
        `either party may terminate this contract by giving ${probationNotice} days notice in ` +
        `writing or payment of ${probationNotice} days salary in lieu thereof. In probation you ` +
        "will be entitled with regular employee statutory standards.",
    },
  ]);

  // ===== 2. LEAVE POLICY =====
  richPara([
    { text: "2. Leave Policy", font: "bold" },
    {
      text:
        " You will be entitled with mandatory public holidays, Sundays and one paid holiday as " +
        "per the leave policy. Any other leave taken will be treated as Leave without pay.",
    },
  ]);

  // ===== 3. TERMINATION =====
  richPara([
    { text: "3. Termination", font: "bold" },
    {
      text:
        " Termination of your service with our School happens due to unauthorized absence from " +
        "duty, non performance, misconduct, fraud, negligence, theft, willful violation of our " +
        "school rules, misappropriation, imprisonment or censure by the court of law or as it may " +
        "deem fit in the instant case, the school will not be bound to pay any notice period.",
    },
  ]);

  // ===== 4. NOTICE PERIOD =====
  richPara([
    { text: "4. Notice Period", font: "bold" },
    {
      text:
        " Where the Faculty/Employee wishes to withdraw from this engagement Three Month’s " +
        "notice or Three month notice pay in lieu of notice is mandatory.",
    },
  ]);

  // ===== 5. EXCLUSIVITY & CONFIDENTIALITY =====
  richPara([
    { text: "5. Exclusivity of employment & Confidentiality", font: "bold" },
    {
      text:
        " This is a full time work and you will be required to devote your entire time exclusively " +
        "for the accomplishment of the objectives as described in your scope of functions.",
    },
  ]);

  richPara([
    {
      text:
        "You are requested to kindly maintain strict confidentiality with regard to all of Annai " +
        "Arul Public School Group’s Academic / Administrative / Financial activities, " +
        "operations, plans etc.",
    },
  ]);

  richPara([
    {
      text:
        "Any act that is in breach of these rules and regulations, or is inconsistent with the " +
        "discharge of your duties will be ground for termination of this contract with immediate " +
        "effect.",
    },
  ]);

  richPara([
    {
      text:
        "We at Annai Arul Public School have the privilege in welcoming you and wish you a very " +
        "successful career with us. We reaffirm our complete confidence in your ability to find " +
        "professional and personal satisfaction here. All who met you reckon that you will be a " +
        "fine asset to AAPS.",
    },
  ]);

  // ===== SALARY FITMENT =====
  doc.addPage();
  y = 63.7;

  doc.setFont("times", "bold");
  doc.setFontSize(SIZE);
  doc.text("Salary Fitment", CENTER, y, { align: "center" });

  // label, value, label bold, value bold
  const rows = [
    ["Name:", employeeName, false, true],
    ["Designation:", designationName, false, false],
    ["Basic", plainAmount(sal.basic), false, false],
    ["HRA", plainAmount(sal.hra), false, false],
    ["Conveyance", plainAmount(sal.convy), false, false],
    ["Washing Allowance", plainAmount(sal.wash_allow), false, false],
    ["Special Conveyance", plainAmount(sal.special_convyance), false, false],
    ["Gross Salary", plainAmount(sal.gross), true, true],
    ["PF Employer", plainAmount(sal.pf_employer), false, false],
    ["ESI Employer", plainAmount(sal.esi_employer), false, false],
    ["Insurance", plainAmount(sal.insurance), false, false],
    ["CTC", plainAmount(sal.ctc), true, true],
    ["PF Employee", plainAmount(sal.pf_employee), false, false],
    ["ESI Employee", plainAmount(sal.esi_employee), false, false],
    ["PT", plainAmount(sal.pt), false, false],
    ["Net Take Home", plainAmount(sal.net_take), true, true],
  ];

  const TABLE_X = LEFT;
  const COL_1 = 88;
  const COL_2 = 88;
  const ROW_H = 5.63;
  const PAD = 1;

  y = 68.8;

  doc.setFontSize(11);
  doc.setDrawColor(0);
  doc.setLineWidth(0.2);

  rows.forEach(([label, value, labelBold, valueBold]) => {
    doc.rect(TABLE_X, y, COL_1, ROW_H);
    doc.rect(TABLE_X + COL_1, y, COL_2, ROW_H);

    const textY = y + 4.2;

    doc.setFont("times", labelBold ? "bold" : "normal");
    doc.text(String(label), TABLE_X + PAD, textY);

    doc.setFont("times", valueBold ? "bold" : "normal");
    doc.text(
      String(value === "" || value === null || value === undefined ? "-" : value),
      TABLE_X + COL_1 + COL_2 / 2,
      textY,
      { align: "center" }
    );

    y += ROW_H;
  });

  y += 10.7;

  richPara(
    [{ text: "Best Wishes for many happy, rewarding and mutually beneficial career with us." }],
    { align: "center" }
  );

  // ===== SIGNATURE + ACCEPTANCE =====
  richPara([{ text: "Sincerely," }]);
  richPara([{ text: "For Annai Arul Public School,", font: "bold" }], { gap: 0 });
  richPara([{ text: "(Dean)", font: "bold" }]);

  richPara([
    {
      text:
        "I have read, understood and accept the above terms and conditions of employment. Also, I " +
        "am aware that I will be governed by the service rules and regulations of Annai Arul " +
        "Public School.",
    },
  ]);

  doc.setFont("times", "bold");
  doc.setFontSize(SIZE);
  doc.text("Date: _______________________", LEFT, y);
  doc.text("(Signature of the Candidate)", 81, y);

  // ===== SAVE =====
  doc.save(`Appointment_Order_${users.employee_id}.pdf`);
};


const generateExperienceCertificate = () => {
  const doc = new jsPDF("p", "mm", "a4");

  const LEFT = 25;
  const MAX_W = 160;
  const LINE = 6.5;

  let y = 55; // top space kept blank for the printed letterhead

  // ===== Helpers =====
  const formatOrdinalDate = (date, monthStyle = "long") => {
    const d = new Date(date);
    if (isNaN(d.getTime())) return "";

    const day = d.getDate();
    const suffix =
      day % 10 === 1 && day !== 11
        ? "st"
        : day % 10 === 2 && day !== 12
        ? "nd"
        : day % 10 === 3 && day !== 13
        ? "rd"
        : "th";

    return `${String(day).padStart(2, "0")}${suffix} ${d.toLocaleDateString(
      "en-GB",
      { month: monthStyle }
    )} ${d.getFullYear()}`;
  };

  // paragraph with mixed bold / normal words, wrapped word by word
  const richPara = (segments, opts = {}) => {
    const { size = 12, gap = 8 } = opts;

    doc.setFontSize(size);

    // flatten into words that remember their own style,
    // so spacing stays uniform across bold / normal parts
    const words = [];
    segments.forEach((seg) => {
      seg.text.split(/\s+/).forEach((word) => {
        if (word) words.push({ word, bold: seg.bold });
      });
    });

    doc.setFont("times", "normal");
    const spaceW = doc.getTextWidth(" ");

    let x = LEFT;

    words.forEach(({ word, bold }) => {
      doc.setFont("times", bold ? "bold" : "normal");

      const w = doc.getTextWidth(word);

      if (x > LEFT && x + w > LEFT + MAX_W) {
        x = LEFT;
        y += LINE;
      }

      doc.text(word, x, y);
      x += w + spaceW;
    });

    y += LINE + gap;
  };

  const para = (text, opts = {}) => {
    const { font = "normal", size = 12, gap = 8 } = opts;

    doc.setFont("times", font);
    doc.setFontSize(size);

    const lines = doc.splitTextToSize(text, MAX_W);
    doc.text(lines, LEFT, y);
    y += lines.length * LINE + gap;
  };

  // ===== Employee data =====
  const title = getTitle(users.gender, users.marital_status);

  const employeeName = `${users.first_name || ""} ${users.last_name || ""}`.trim();

  const designationName =
    designationDropdownOptions.find((d) => d.designation_id == designation)
      ?.designation_name || "";

  const departmentName =
    dataval.find((d) => d.department_id == department)?.department_name || "";

  const isMale = users.gender === "Male";
  const subject = isMale ? "he" : "she";
  const possessive = isMale ? "his" : "her";
  const object = isMale ? "him" : "her";

  const leavingDate = users.date_of_leaving || new Date();

  // ===== DATE (Right aligned) — always the date the letter is generated =====
  doc.setFont("times", "normal");
  doc.setFontSize(12);
  doc.text(formatOrdinalDate(new Date(), "short"), 185, y, { align: "right" });

  y += 25;

  // ===== HEADING =====
  doc.setFont("times", "bold");
  doc.setFontSize(16);
  doc.text("EXPERIENCE CERTIFICATE", 105, y, { align: "center" });

  y += 20;

  // ===== SUB HEADING =====
  doc.setFontSize(12.5);
  const subHeading = "To Whomsoever It May Concern";
  const subHeadingW = doc.getTextWidth(subHeading);
  doc.text(subHeading, 105, y, { align: "center" });
  doc.line(105 - subHeadingW / 2, y + 1.5, 105 + subHeadingW / 2, y + 1.5);

  y += 20;

  // ===== BODY =====
  richPara([
    { text: "This is to certify that " },
    { text: `${title} ${employeeName}`, bold: true },
    { text: " was employed with our organization Annai Arul Hospital from " },
    { text: formatOrdinalDate(users.date_of_joining), bold: true },
    { text: " to " },
    { text: formatOrdinalDate(leavingDate), bold: true },
    {
      text: ` as ${designationName}${
        departmentName ? ` in ${departmentName}` : ""
      }.`,
    },
  ]);

  para(
    `In our opinion, ${subject} was such a motivated, duty bound and highly committed team member that ${possessive} knowledge was quite a valuable asset to our organization.`
  );

  para(
    `We at Annai Arul Hospital wish ${object} all success in ${possessive} future endeavors.`,
    { gap: 18 }
  );

  // ===== SIGNATURE =====
  para("For Annai Arul Hospital,", { gap: 6 });
  para("Regards,", { gap: 26 });

  doc.setFont("times", "bold");
  doc.setFontSize(12);
  doc.text("Jebin Samuel J", LEFT, y);

  y += LINE;
  doc.setFont("times", "normal");
  doc.text("Manager - Human Resources", LEFT, y);

  // ===== SAVE =====
  doc.save(`Experience_Certificate_${users.employee_id}.pdf`);
};


const generateRelievingLetter = () => {
  const doc = new jsPDF("p", "mm", "a4");

  const LEFT = 15;
  const RIGHT = 193;
  const CENTER = (LEFT + RIGHT) / 2;
  const ADDR_X = 17;
  const RECORD_X = 16;
  const RECORD_VALUE_X = 106;
  const MAX_W = RIGHT - LEFT;
  const SIZE = 12;
  const LINE = 5.5;
  const PARA_GAP = 5.5;

  let y = 74.65; // top space kept blank for the printed letterhead

  // ===== Helpers =====
  const formatDate = (date) => {
    const d = new Date(date);
    if (isNaN(d.getTime())) return "";

    return [
      String(d.getDate()).padStart(2, "0"),
      String(d.getMonth() + 1).padStart(2, "0"),
      d.getFullYear(),
    ].join("-");
  };

  // split styled segments into words and the whitespace between them so a
  // paragraph can mix normal and bold runs and still wrap on the column
  const tokenize = (segments) => {
    const tokens = [];
    segments.forEach(({ text, font = "normal" }) => {
      String(text).split(/(\s+)/).forEach((piece) => {
        if (piece === "") return;
        tokens.push({ text: piece, font, space: /^\s+$/.test(piece) });
      });
    });
    return tokens;
  };

  // draw consecutive same-font tokens as one string so the font keeps its own
  // kerning instead of every word being placed at a measured offset
  const drawLine = (tokens, x, align) => {
    const runs = [];
    tokens.forEach((token) => {
      const last = runs[runs.length - 1];
      if (last && last.font === token.font) last.text += token.text;
      else runs.push({ text: token.text, font: token.font });
    });

    let total = 0;
    runs.forEach((run) => {
      doc.setFont("times", run.font);
      total += doc.getTextWidth(run.text);
    });

    let cx = x;
    if (align === "center") cx = CENTER - total / 2;
    else if (align === "right") cx = RIGHT - total;

    runs.forEach((run) => {
      doc.setFont("times", run.font);
      doc.text(run.text, cx, y);
      cx += doc.getTextWidth(run.text);
    });

    return total;
  };

  const richPara = (segments, opts = {}) => {
    const { x = LEFT, width = MAX_W, gap = PARA_GAP, align = "left" } = opts;

    doc.setFontSize(SIZE);

    let line = [];
    let lineW = 0;
    let lastWidth = 0;

    const flush = () => {
      lastWidth = drawLine(line, x, align);
      y += LINE;
      line = [];
      lineW = 0;
    };

    tokenize(segments).forEach((token) => {
      doc.setFont("times", token.font);
      const w = doc.getTextWidth(token.text);

      if (lineW + w > width && line.length) {
        flush();
        if (token.space) return; // drop the space that caused the wrap
      }

      line.push(token);
      lineW += w;
    });

    if (line.length) flush();
    y += gap;

    return lastWidth;
  };

  // a line of the service record: label on the left, value in the second column
  const record = (label, value) => {
    doc.setFont("times", "normal");
    doc.setFontSize(SIZE);
    doc.text(label, RECORD_X, y);
    doc.text(`: ${value}`, RECORD_VALUE_X, y);
    y += LINE;
  };

  // ===== Employee data =====
  const title = getTitle(users.gender, users.marital_status);

  const employeeName = `${users.first_name || ""} ${users.last_name || ""}`.trim();

  const designationName =
    designationDropdownOptions.find((d) => d.designation_id == designation)
      ?.designation_name || "";

  // relieving date comes from the exit procedure approved by HR
  const relievingDate =
    exitDetail?.releave_date || users.date_of_leaving || new Date();

  // ===== DATE (right aligned) =====
  richPara(
    [{ text: "Date:", font: "bold" }, { text: ` ${formatDate(new Date())}` }],
    { align: "right" }
  );

  // ===== ADDRESS BLOCK =====
  richPara([{ text: `${title} ${employeeName}`.trim(), font: "bold" }], {
    x: ADDR_X,
    gap: 0,
  });

  if (designationName) {
    richPara([{ text: designationName }], { x: ADDR_X, gap: 0 });
  }

  richPara(
    [
      { text: "Employee ID: " },
      { text: `AAPS/${users.employee_id || ""}`, font: "bold" },
    ],
    { x: ADDR_X, gap: 0 }
  );

  richPara([{ text: "Annai Arul Public School" }], { x: ADDR_X, gap: 0 });
  richPara([{ text: "No.1, Padmanabha Main Road," }], { x: ADDR_X, gap: 0 });
  richPara([{ text: "Madambakkam, Chennai – 600126" }], { x: ADDR_X });

  // ===== HEADING =====
  doc.setFont("times", "bold");
  doc.setFontSize(SIZE);
  doc.text("RELIEVING ORDER", CENTER, y, { align: "center" });
  const headingW = doc.getTextWidth("RELIEVING ORDER");
  doc.setLineWidth(0.4);
  doc.line(CENTER - headingW / 2, y + 1.2, CENTER + headingW / 2, y + 1.2);

  y += LINE + PARA_GAP;

  // ===== SALUTATION =====
  richPara([{ text: `Dear ${title} ${users.first_name || ""},`.trim() }]);

  richPara([{ text: "SUB:", font: "bold" }, { text: " Relieving Order" }]);

  // ===== BODY =====
  richPara([
    {
      text:
        "With reference to your resignation, you are hereby informed that your resignation has " +
        "been accepted, and you are relieved from the services of our institution as on the close " +
        "of working hours on ",
    },
    { text: formatDate(relievingDate), font: "bold" },
    { text: "." },
  ]);

  // ===== SERVICE RECORD =====
  richPara([{ text: "Your service record is as follows:" }]);

  record("Name", employeeName);
  record("Last Held Role", designationName);
  record("Date of Joining", formatDate(users.date_of_joining));
  record("Date of Leaving", formatDate(relievingDate));

  y += PARA_GAP;

  richPara([{ text: "Wishing you all the best!" }]);

  // ===== SIGNATURE =====
  richPara([{ text: "DEAN", font: "bold" }], { align: "right" });

  // ===== SAVE =====
  doc.save(`Relieving_Letter_${users.employee_id}.pdf`);
};



		const [salaryUpdateStatus, setSalaryUpdateStatus] = useState("");
		// true once a mother tongue has been saved, which makes the field read only
		const [motherTongueLocked, setMotherTongueLocked] = useState(false);
		const [exitDetail, setExitDetail] = useState(null);
		const [users, setUsers] = useState({
			first_name: "",
			last_name: "",
			blood_group: "",
			username:"",
			email:"",
			gender: "",
			date_of_joining: "",
			date_of_leaving: "",
			reason_status: "",
			inactive_reason:"",
			floor_id:"",
			pan_no:"",
			adhar_no:"",
			uan_no:"",
			marital_status:"",
			role:"",
			date_of_birth:"",
			password:"",
			confirm_password:"",
			contact_no:"",
			employee_type:"",
			address:"",
			employee_shift:"",
			contractor:"",
			contractor_type:"",
			pre_pfno:"",
			esi_no:"",
			qualification:"",
			is_active:"",
			experience:"",
			notice_period:"",
			tds_applicable:"",
			pf_status:"",
			notice_period_status:"",
			flat_status:"",
			// current_salary:"",
			// expected_salary:"",
			user_role_id:"",
	
		})


		const handelInput = (event) => {
			event.preventDefault();
			const { name, value } = event.target;
			console.log(name, value)
			setUsers({ ...users, [name]: value });
		}


		const [floorval, setfloorval]= useState([]);
		const [dataval, setdataval]= useState([]);
		const [roleval, setroleval]= useState([]);
		const [current_salary, setCurrentSalary] = useState("");
		const [expected_salary, setExpectedSalary] = useState("");
		const [adhar_no, setAdharNo] = useState("");
		



		const handelNumber = (e) => {
			const inputValue = e.target.value;
		
			// Allow only numeric characters
			if (/^\d*$/.test(inputValue)) {
				setCurrentSalary(inputValue);
			}
		  };

		  const handelNumber1 = (e) => {
			const inputValue = e.target.value;
		
			// Allow only numeric characters
			if (/^\d*$/.test(inputValue)) {
				setExpectedSalary(inputValue);
			}
		  };

		  const handelNumber2 = (e) => {
			const inputValue = e.target.value;
		
			// Allow only numeric characters
			if (/^\d*$/.test(inputValue)) {
				setAdharNo(inputValue);
			}
		  };


	const { search } = useLocation();
	const searchparams = new URLSearchParams(search);
	const param = searchparams.get("id");


	useEffect(() => {
		axios.get(API_BASE_URL + '/showempdetail/' + param, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		
			// .then(res => console.log(res.data.last_salary_update_status))
			  .then(res =>  {
				// console.log("Salary Status:", res.data.last_salary_update_status);
				setUsers(res.data.emp_detail[0])
				setSalaryUpdateStatus(res.data.last_salary_update_status)
				setExitDetail(res.data.exit_detail || null)
				setDepartmentValue(res.data.emp_detail[0].department_id)
				setCurrentSalary(res.data.emp_detail[0].current_salary)
				setExpectedSalary(res.data.emp_detail[0].expected_salary)
				setAdharNo(res.data.emp_detail[0].adhar_no)
				setDesignationValue(res.data.emp_detail[0].designation_id)
				fetchSecondDropdownOptions(res.data.emp_detail[0].department_id)
				setEmployeeshift(res.data.emp_detail[0].employee_shift)
				setContractorValue(res.data.emp_detail[0].contractor)
				setContractorTypeValue(res.data.emp_detail[0].contractor_type)
				fetchContractorTypeDropdownOptions(res.data.emp_detail[0].contractor)
				fetchProfilePicture(res.data.emp_detail[0].profile_picture)
				// mother tongue is recorded once — remember whether it arrived
				// already filled in, so the field locks after the first save
				setMotherTongueLocked(!!String(res.data.emp_detail[0].mother_tongue || '').trim())
				// setContractorValue(res.data.emp_detail[0].employee_type_id)
			  			}		)	.catch(err => console.log(err));
			
	}, [])


	const isReadonly = String(salaryUpdateStatus)?.trim().toUpperCase() === "PENDING";

console.log("Salary Status:", salaryUpdateStatus);
console.log("Readonly:", isReadonly);


	const handleFloor = async () => {

		axios.get(API_BASE_URL +'/showfloor', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		.then(res1 => setfloorval(res1.data))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleFloor();
	  }, []);

	  const handleRole = async () => {

		axios.get(API_BASE_URL +'/showrole', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		.then(res1 => setroleval(res1.data))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleRole();
	  }, []);


	  const handleDepartment = async () => {

		axios.get(API_BASE_URL +'/showdepartment', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		.then(res1 => setdataval(res1.data))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleDepartment();
	  }, []);


	   const [department, setDepartmentValue] = useState("");
	   const [designationDropdownOptions,setDesignationDropdownOptions]=useState([]);
	   const [designation,setDesignationValue] = useState("");
	   const [contact_no, setNumValue] = useState("");
	   //const [firstDropdownValue, setFirstDropdownValue] = useState("");
	  //   const [secondDropdownOptions, setSecondDropdownOptions] = useState([]);
	  //   const [secondDropdownValue, setSecondDropdownValue] = useState("");
	  
		// Handle first dropdown change
		const handleFirstDropdownChange = (event) => {
		  const value = event.target.value;
		  setDepartmentValue(value);
	  
		  // Trigger API call based on the selected value
		  fetchSecondDropdownOptions(value);
		};
	  
	  
	  
		 // Fetch options for the second dropdown
		 const fetchSecondDropdownOptions = async (selectedValue) => {
		  try {
		  
		const response = await fetch(
			  API_BASE_URL + '/showdesignationcheck/'+selectedValue, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}
			); // Replace with your API URL
	  
			const data = await response.json();
			setDesignationDropdownOptions(data); // Assuming the API returns an array of options
		  } catch (error) {
			console.error("Error fetching second dropdown options:", error);
		  }
		};
	  
		  // Handle second dropdown change
		const handleSecondDropdownChange = (event) => {
			// setSecondDropdownValue(event.target.value);
			setDesignationValue(event.target.value);
		  };
	  



	  const [employee_shift,setEmployeeshift]= useState("");
	  const [contractordata,setContractorData]= useState([]);
	  const [contractor,setContractorValue]= useState("");
	  const [contractotypeDropdownOptions,setContractorTypeDropdownOptions]= useState([]);
	  const [contractortype,setContractorTypeValue]= useState("");
	  const [shiftemployee,setShiftEmployee]=useState("");


	  const handleContractor = async () => {

		axios.get(API_BASE_URL +'/showcontractor', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		.then(res1 => setContractorData(res1.data))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleContractor();
	  }, []);



	  const handleContractorDropdownChange = (event) => {
		const value = event.target.value;
		setContractorValue(value);
	
		// Trigger API call based on the selected value
		fetchContractorTypeDropdownOptions(value);
	  };
	
	
	
	//    Fetch options for the second dropdown
	   const fetchContractorTypeDropdownOptions = async (selectedValue) => {
		try {
		
		const response = await fetch(
			API_BASE_URL + '/showcontractortype/'+selectedValue,{
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}
		  ); // Replace with your API URL
	
		  const data = await response.json();
		  setContractorTypeDropdownOptions(data); // Assuming the API returns an array of options
		} catch (error) {
		  console.error("Error fetching second dropdown options:", error);
		}
	  };
	
		// Handle second dropdown change
		const handleContractorTypeDropdownChange = (event) => {
			// setSecondDropdownValue(event.target.value);
			setContractorTypeValue(event.target.value);
		  };


		  const handelShiftEmployee = (event) => {

			setEmployeeshift(event.target.value);
	
			// if (event.target.value === '1') {
			// 	setIsVisible(true);
			// } else {
			// 	setIsVisible(false);
			// }
		}


	const handleEditSubmit = (e) => {

		

		e.preventDefault();
		
		// console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();
		// alert('hi');

		    const payload = {
        first_name: users.first_name,
        last_name: users.last_name,
        username: users.username,
        blood_group: users.blood_group,
        email: users.email,
        gender: users.gender,
        floor_id: users.floor_id,
        contact_no: users.contact_no,
        department_id: department,
        designation_id: designation,
        date_of_birth: users.date_of_birth,
        date_of_joining: users.date_of_joining,
        pan_no: users.pan_no,
        adhar_no: adhar_no,
        uan_no: users.uan_no,
        marital_status: users.marital_status,
        pre_pfno: users.pre_pfno,
        esi_no: users.esi_no,
        qualification: users.qualification,
        status: users.is_active,
        experience: users.experience,
        notice_period: users.notice_period,
        tds_applicable: users.tds_applicable,
        pf_status: users.pf_status,
        notice_period_status: users.notice_period_status,
        flat_status: users.flat_status,
        current_salary: current_salary,
        expected_salary: expected_salary,
        user_role_id: users.user_role_id,
        employee_shift: employee_shift,
        contractor: contractor,
        contractor_type: contractortype,
        // drop stray blank lines / trailing spaces so the appointment order prints one clean address
        address: String(users.address || '')
          .split(/\r?\n/)
          .map((line) => line.trim())
          .filter(Boolean)
          .join('\n'),
        mother_tongue: users.mother_tongue,
        id: users.user_id,
    };

    // ✅ If employee inactive (resigned) add leaving details
    if (users.is_active == 0) {
        payload.date_of_leaving = users.date_of_leaving;
        payload.inactive_reason = users.inactive_reason;
		payload.reason_status = users.reason_status;
    }


// console.log(payload);
		// ,pre_pfno:users.pre_pfno,esi_no:users.esi_no,qualification:users.qualification,status:users.is_active,experience:users.experience,notice_period:users.notice_period,
		axios.post(API_BASE_URL + '/updateempdetail', payload, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// console.log(response);
			// // 	console.log(response.data.message);
			//  })
console.log(response.data);
			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				// const timeout = setTimeout(() => {
				// 	window.location.reload(); // Reload the current page
				// }, 5000); // Refresh after 5 seconds

				// return () => {
				// 	clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				// };

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};


	const [allemployeeval, setallemployeeval]= useState([]);
	const [inchargeval,setInchargeValue]= useState("");
	const [hodval,setHodValue]= useState("");


	const handleAllEmployee = async () => {

		axios.get(API_BASE_URL +'/showallemployee', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		// .then(res1 => console.log(res1.data.user_det))
		.then(res1 => setallemployeeval(res1.data.user_det))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleAllEmployee();
	  }, []);


	  useEffect(() => {
		axios.get(API_BASE_URL + '/approvalinformation/' + param, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
			// .then(res => console.log(res.data.emp_detail[0].first_name))
			  .then(res =>  {
				setInchargeValue(res.data.incharge_id)
				setHodValue(res.data.hod_id)
				
				// setContractorValue(res.data.emp_detail[0].employee_type_id)
			  			}		)	.catch(err => console.log(err));
			
	}, [])



	const approvalEmployeeOptions = [
		{ value: "", label: "None" },
		...allemployeeval.map(option => ({
			value: String(option.user_id),
			label: `${option.first_name} ${option.last_name} ${option.employee_id}`
		}))
	];

	const approvalSelectStyles = {
		control: (base) => ({
			...base,
			minHeight: "38px",
			borderRadius: "4px",
			borderColor: "#ced4da",
			boxShadow: "none",
			fontSize: "13px",
			"&:hover": { borderColor: "#b3b3b3" }
		}),
		menu: (base) => ({
			...base,
			borderRadius: "4px",
			zIndex: 9999
		}),
		menuPortal: (base) => ({ ...base, zIndex: 9999 }),
		option: (base, state) => ({
			...base,
			fontSize: "13px",
			padding: "6px 10px",
			backgroundColor: state.isFocused ? "#f8f9fa" : "white",
			color: "#333"
		})
	};


	const handleapprovalinchargeChange = (selected) => {
		//  console.log(selected);
		setInchargeValue(selected ? selected.value : "");

	  };


	  const handleapprovalhodChange = (selected) => {
		// console.log(selected);
		setHodValue(selected ? selected.value : "");

	  };

	  const handleApprovalSubmit = (e) => {

		

		e.preventDefault();

		//  alert(inchargeval);
		// alert(hodval);
		
		// console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();

		// ,pre_pfno:users.pre_pfno,esi_no:users.esi_no,qualification:users.qualification,status:users.is_active,experience:users.experience,notice_period:users.notice_period,
		axios.post(API_BASE_URL + '/updateempapproval', { incharge_id: inchargeval,hod_id:hodval,id:param}, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// console.log(response);
			// // 	console.log(response.data.message);
			//  })

			console.log(response.data);
			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				// const timeout = setTimeout(() => {
				// 	window.location.reload(); // Reload the current page
				// }, 5000); // Refresh after 5 seconds

				// return () => {
				// 	clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				// };

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};





    
	// first salary ever added for this employee - the appointment order uses this
	const [firstSalary, setFirstSalary] = useState(null);
	const [gross_salary, setGross] = useState("");
	const [convy, setConvy] = useState("0");
	const[wash_allow,setWashAllow]=useState("0");
	const [basic_salary, setBasicSalary] = useState("");
	const [hra, setHra] = useState("");
	const [special_convyance, setSpecialConvyance] = useState("");
	const [pf_employer, setPfEmployer] = useState("");
	const [esi_employer, setEsiEmployer] = useState("");
	const [pf_employee, setPfEmployee] = useState("");
	const [esi_employee, setEsiEmployee] = useState("");
	const [insurance, setInsurance] = useState("0");
	const [pt, setPt] = useState("");
	const [hostel_fee, setHostelFee] = useState("0");
	const [tds, setTds] = useState("");
	const [ctc, setCtc] = useState("");
	const [net_take, setNettake] = useState("");
	const [uan_no, setUanNo] = useState("");
	const [account_no, setAccountNo] = useState("");
	const [bank_name, setBankName] = useState("");
	const [branch_name, setBranchName] = useState("");
	const [ifsc_no, setIfscNo] = useState("");
	const [pf_no, setPfNo] = useState("");
	const [esi_no, setEsiNo] = useState("");

	const handelsalaryInput = (gross,con,wash,insur,hostfee) => {


		


		axios.post(API_BASE_URL + '/showsalaryfitment', { gross_salary: gross,convy:con,wash_allow:wash,insurance:insur,hostel_fee:hostfee}, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(res1 =>  {
			setBasicSalary(res1.data.basic_salary)
			setHra(res1.data.hra)
			setPfEmployer(res1.data.pf_employer)
			setPfEmployee(res1.data.pf_employee)
			setEsiEmployer(res1.data.esi_employer)
			setEsiEmployee(res1.data.esi_employee)
			setPt(res1.data.pt)
			setCtc(res1.data.ctc)
			setNettake(res1.data.net_take)
		}

		 )
			.catch(err => console.log(err));
	};


	const handleSalarySubmit = async (e) => {

		e.preventDefault();
	   
	
		// setError(null);
		// setLoading(true);
		// e.preventDefault();
		axios.post(API_BASE_URL+'/addsalaryinfo', { gross_salary: gross_salary, convy: convy ?? "0",wash_allow: wash_allow ?? "0",basic_salary: basic_salary, hra: hra,special_convyance: special_convyance,pf_employer: pf_employer,esi_employer: esi_employer,pf_employee: pf_employee,esi_employee: esi_employee,insurance: insurance ?? "0",hostel_fee: hostel_fee ?? "0",pt: pt, ctc: ctc, net_take: net_take,uan_no:uan_no,account_no:account_no,bank_name:bank_name ?? "",branch_name:branch_name ?? "",ifsc_no:ifsc_no ?? "",pf_no:pf_no,esi_no:esi_no,user_id:param}, {
						headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
					}).then(response => {
			// 	console.log(response.data);
			// 	console.log(response.data.message);
			// })
	
			var status = response.data.status;
	
			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",
	
				});
	
	
				// const timeout = setTimeout(() => {
				// 	window.location.reload(); // Reload the current page
				// }, 5000); // Refresh after 5 seconds
	
				// return () => {
				// 	clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				// };
	
			} else if(status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",
	
				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",
	
				});
			}
	
	
		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);
	
	
	
	
			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",
	
	
			});
	
		});
	};


	useEffect(() => {
		axios.get(API_BASE_URL + '/displaysalarydetail/' + param, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
			// .then(res => console.log(res.data.emp_detail[0].first_name))
			  .then(res =>  {
				setFirstSalary(res.data.first_salary || null)
				setGross(res.data.gross_salary)
				setConvy(res.data.convy ?? "0")
				setWashAllow(res.data.wash_allow ?? "0")
				setBasicSalary(res.data.basic_salary)
			setHra(res.data.hra)
			setSpecialConvyance(res.data.special_convyance)
			setPfEmployer(res.data.pf_employer)
			setPfEmployee(res.data.pf_employee)
			setEsiEmployer(res.data.esi_employer)
			setEsiEmployee(res.data.esi_employee)
			setPt(res.data.pt)
			setInsurance(res.data.insurance ?? "0")
			setHostelFee(res.data.hostel_fee ?? "0")
			setCtc(res.data.ctc)
			setNettake(res.data.net_take)
			setUanNo(res.data.uan_no)
			setAccountNo(res.data.account_no)
			setBankName(res.data.bank_name ?? "")
			setBranchName(res.data.branch_name ?? "")
			setIfscNo(res.data.ifsc_no ?? "")
			setPfNo(res.data.pf_no)
			setEsiNo(res.data.esi_no)
				
				// setContractorValue(res.data.emp_detail[0].employee_type_id)
			  			}		)	.catch(err => console.log(err));
			
	}, [])

	

	const [newpassword,setNewPassword]= useState("");
	const [confirmnewpassword,setConfirmNewPassword]= useState("");


	const handleNewPasswordChange = (event) => {
		const value = event.target.value;
		setNewPassword(value);
	
	  };


	  const handleConfirmNewPasswordChange = (event) => {
		const value = event.target.value;
		setConfirmNewPassword(value);
	
	  };

	const handleChangePaswordSubmit = (e) => {

		

		e.preventDefault();
		
		// console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();

		// ,pre_pfno:users.pre_pfno,esi_no:users.esi_no,qualification:users.qualification,status:users.is_active,experience:users.experience,notice_period:users.notice_period,
		axios.post(API_BASE_URL + '/changepassword', { password: newpassword,confirm_password:confirmnewpassword,id:param}, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// console.log(response);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				// const timeout = setTimeout(() => {
				// 	window.location.reload(); // Reload the current page
				// }, 5000); // Refresh after 5 seconds

				// return () => {
				// 	clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				// };

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};


	const [image, setImage] = useState(null);
	const [preview, setPreview] = useState(null);
	const [uploading, setUploading] = useState(false);
	const [fetchprofile,fetchProfilePicture]= useState("");

	const imagepath=UPLOADS_BASE_URL+'/uploads/profile/'+fetchprofile;


	const handleImageChange = (event) => {
		const file = event.target.files[0];
		if (file) {
		  setImage(file);
		//   setPreview(URL.createObjectURL(file)); // Preview image
		}
	  };


	  const handleProfileSubmit = (e) => {

		

		e.preventDefault();
		
		// console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();

		// ,pre_pfno:users.pre_pfno,esi_no:users.esi_no,qualification:users.qualification,status:users.is_active,experience:users.experience,notice_period:users.notice_period,
		axios.post(API_BASE_URL + '/profilepicture', { image: image,id:param}, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}`,'Content-Type': 'multipart/form-data' },
		}).then(response => {
			// console.log(response);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				// const timeout = setTimeout(() => {
				// 	window.location.reload(); // Reload the current page
				// }, 5000); // Refresh after 5 seconds

				// return () => {
				// 	clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				// };

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};

	const [edu, setEdu] = useState({
		qualification_name: "",
		educationlevel: "",
		from_year: "",
		to_year:"",
		language:"",
		skill: "",
		description: "",
	})


	const handelEducationInput = (event1) => {
		event1.preventDefault();
		const { name1, value1 } = event1.target;
		console.log(event1.target.value)
		setEdu({ ...edu, [event1.target.name]: event1.target.value });
	}



	const [alleducationlevel,setalleducationlevel]=useState([]);
	const [allqualificationlanguage,setallqualificationlanguage]=useState([]);
	const [allqualificationskill,setallqualificationskill]=useState([]);



	const handleAllEducationLevel = async () => {

		axios.get(API_BASE_URL +'/alleducationlevel', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		//  .then(res1 => console.log(res1.data))
		.then(res1 => setalleducationlevel(res1.data))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleAllEducationLevel();
	  }, []);



	  const handleAllQualificationLanguage = async () => {

		axios.get(API_BASE_URL +'/allqualificationlanguage/', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		//   .then(res1 => console.log(res1.data))
		 .then(res1 => setallqualificationlanguage(res1.data))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleAllQualificationLanguage();
	  }, []);


	  const handleAllQualificationSkill = async () => {

		axios.get(API_BASE_URL +'/allqualificationskill', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		//   .then(res1 => console.log(res1.data))
		 .then(res1 => setallqualificationskill(res1.data))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleAllQualificationLanguage();
	  }, []);



	  const handleQualifcationSubmit = (e) => {

		

		e.preventDefault();
		
		// console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();

		// alert(edu.educationlevel);

		// ,pre_pfno:users.pre_pfno,esi_no:users.esi_no,qualification:users.qualification,status:users.is_active,experience:users.experience,notice_period:users.notice_period,
		axios.post(API_BASE_URL + '/addqualification', { qualification_name: edu.qualification_name,education_level:edu.educationlevel,from_year:edu.from_year,to_year:edu.to_year,language:edu.language,skill:edu.skill,description:edu.description,user_id:param}, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// console.log(response);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				// const timeout = setTimeout(() => {
				// 	window.location.reload(); // Reload the current page
				// }, 5000); // Refresh after 5 seconds

				// return () => {
				// 	clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				// };

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};


	const emptyWork={
		company_name: "",
		post: "",
		from_date: "",
		to_date:"",
		description: "",
	}


	const [work, setWork] = useState({
		company_name: "",
		post: "",
		from_date: "",
		to_date:"",
		description: "",
	})


	const handelWorkExpInput = (event2) => {
		event2.preventDefault();
		const { name1, value1 } = event2.target;
		console.log(event2.target.value)
		setWork({ ...work, [event2.target.name]: event2.target.value });
	}



	const handleWorkingExpSubmit = (e) => {

		

		e.preventDefault();
		
		// console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();

	//    alert(work.company_name);

		// ,pre_pfno:users.pre_pfno,esi_no:users.esi_no,qualification:users.qualification,status:users.is_active,experience:users.experience,notice_period:users.notice_period,
		axios.post(API_BASE_URL + '/addworkingexperience', { company_name: work.company_name,post:work.post,from_date:work.from_date,to_date:work.to_date,description:work.description,user_id:param}, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// console.log(response);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				// const timeout = setTimeout(() => {
				// 	window.location.reload(); // Reload the current page
				// }, 5000); // Refresh after 5 seconds

				// return () => {
				// 	clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				// };

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};



	const [data, setData] = useState([]);
	

	useEffect(() => {
		axios.get(API_BASE_URL + '/fetchworkexperience', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})


			.then(res => setData(res.data))
			//.then(res => console.log(res.data))
			.catch(err => console.log(err));
	}, [])



	const handleUpdate = async (id) => {

		axios.get(API_BASE_URL + '/showworkexp/' + id, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
			.then(res1 => setWork(res1.data))
			.catch(err => console.log(err))
	};




	const handleEditWorkExpSubmit = (e) => {

		e.preventDefault();

		// console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();
		axios.post(API_BASE_URL + '/updateworkexp', { company_name: work.company_name, post: work.post, from_date: work.from_date,to_date:work.to_date,description:work.description,id: work.work_experience_id }, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// console.log(response.data);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				const timeout = setTimeout(() => {
					window.location.reload(); // Reload the current page
				}, 5000); // Refresh after 5 seconds

				return () => {
					clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				};

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};


	const [alldocumenttypelevel,setalldocumenttypelevel]=useState([]);
	// const [allqualificationlanguage,setallqualificationlanguage]=useState([]);
	// const [allqualificationskill,setallqualificationskill]=useState([]);


	const handleAllDocumentLevel = async () => {

		axios.get(API_BASE_URL +'/alldocumenttype/', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		//   .then(res1 => console.log(res1.data))
		 .then(res1 => setalldocumenttypelevel(res1.data))
		.catch(err => console.log(err))
	   };


	   useEffect(() => {
		handleAllDocumentLevel();
	  }, []);



	  const [document, setDocument] = useState({
		document_type: "",
		date_of_expiry: "",
		document_title: "",
		document_file:"",
		description: "",
	})

	const [docfile,setDocFile]=useState(null);

	const handleDocumentChange = (event) => {
		const file = event.target.files[0];
		if (file) {
			setDocFile(file);
		//   setPreview(URL.createObjectURL(file)); // Preview image
		}
	  };


	const handelDocumentUploadInput = (event2) => {
		event2.preventDefault();
		const { name1, value1 } = event2.target;
		console.log(event2.target.value)
		setDocument({ ...document, [event2.target.name]: event2.target.value });
	}



	const handleDocumentUploadSubmit = (e) => {

		

		e.preventDefault();
		
		// console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();

	//    alert(work.company_name);

		// ,pre_pfno:users.pre_pfno,esi_no:users.esi_no,qualification:users.qualification,status:users.is_active,experience:users.experience,notice_period:users.notice_period,
		axios.post(API_BASE_URL + '/adddocument', { document_type: document.document_type,date_of_expiry:document.date_of_expiry,title:document.title,document_file:docfile,description:document.description,user_id:param}, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}`,'Content-Type': 'multipart/form-data' },
		}).then(response => {
			// console.log(response);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				// const timeout = setTimeout(() => {
				// 	window.location.reload(); // Reload the current page
				// }, 5000); // Refresh after 5 seconds

				// return () => {
				// 	clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				// };

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};



	const [docfetch, setDocFetch] = useState([]);
	

	useEffect(() => {
		axios.get(API_BASE_URL + '/fetchdocument/'+param, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})


			.then(res => setDocFetch(res.data))
			// .then(res => console.log(res.data))
			.catch(err => console.log(err));
	}, [])




	const handleDocUpdate = async (id) => {

		axios.get(API_BASE_URL + '/showdoctype/' + id, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
			.then(res1 => setDocument(res1.data))
			.catch(err => console.log(err))
	};

    const filepath=APP_BASE_URL+'/uploads/document/'+document.document_file;


	const handleEditDocumentSubmit = (e) => {

		

		e.preventDefault();

		
		// setError(null);
		// setLoading(true);
		// e.preventDefault();
		axios.post(API_BASE_URL + '/updatedocumentdet', { document_type: document.document_type,date_of_expiry:document.date_of_expiry,title:document.title,document_file:docfile,description:document.description,user_id:param,id:document.document_id}, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}`,'Content-Type': 'multipart/form-data' },
		}).then(response => {
			// console.log(response.data);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				const timeout = setTimeout(() => {
					window.location.reload(); // Reload the current page
				}, 5000); // Refresh after 5 seconds

				return () => {
					clearTimeout(timeout); // Cleanup the timeout if the component unmounts
				};

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};



	
// console.log(console.log(users))

const [toggle,setToggle]=useState(false);


	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />
							<div className="d-flex justify-content-between align-items-center mb-3">
								<div className="header-action"></div>
							</div>

						</div>
					</div>


								


					<div className="section-body mt-3">
						<div className="container-fluid">
							<div className="row clearfix">
								<div className="col-md-12">
									<div className="card">

									<div className="card-header">
											<h3 className="card-title" style={{backgroundColor:"#2760fb",color:"white"}}>{users.first_name}&nbsp;{users.last_name} ({users.employee_id})</h3>
										</div>
										
										<div className="card-body" >

										<Accordion title="Basic Information">
										<div className="accordion-body-scroll">
										<div className="card">
								
							
								<div className="card-header">
									
								{/* <div className="section-body mt-3"> */}
								
													<div className="container-fluid">
														<div className="row clearfix">
															<div className="col-md-12">
																<div className="card">


									 <div className="card-body">
										<form onSubmit={handleEditSubmit}>
{/* {typeof users !== 'undefined' &&
console.log(users)
								(	users.map((item, index) => {
										return ( */}

                                            <div class="row" key={users.user_id}>

										{/* <div class="row"> */}

											<div className="col-md-3 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">First Name </label>
													<input
														type="text"
														className="form-control required-input required-tooltip" name="first_name" value={users.first_name} onChange={handelInput}
														placeholder="First Name *"
													/>

													<input name="id" value={users.user_id} type="hidden" />
												</div>
											</div>


											<div className="col-md-3 col-sm-12 required-tooltip">   
												<div className="form-group"> 
												<label className="form-label">Last Name </label>
													<input
														type="text"
														className="form-control required-input required-tooltip"
														placeholder="Last Name" name="last_name" value={users.last_name} onChange={handelInput}
													/>
												</div>
											</div>


											<div className="col-md-3 col-sm-12">   
												<div className="form-group"> 
												<label className="form-label">Blood Group </label>
												{/* <input
														type="text"
														className="form-control"
														placeholder="Last Name" name="blood_group" value={users.blood_group} onChange={handelInput}
													/> */}



													<select className="form-control show-tick" name="blood_group" value={users.blood_group} onChange={handelInput}>
														<option value="">Select Blood Group</option>
														<option value="A+">A+</option>
														<option value="A-">A-</option>
														<option value="B+">B+</option>
														<option value="B-">B-</option>
														<option value="O+">O+</option>
														<option value="O-">O-</option>
														<option value="AB+">AB+</option>
														<option value="AB-">AB-</option>
														
													</select>
												
												</div>
											</div>


											<div className="col-md-3 col-sm-12 ">   
												<div className="form-group"> 
												<label className="form-label">Employee Id</label>
													<input
														type="text"
														className="form-control" disabled
														placeholder="Employee Id" name="employee_id" value={users.employee_id} onChange={handelInput}
													/>
												</div>
											</div>


											<div className="col-md-3 col-sm-12 required-tooltip">   
												<div className="form-group"> 
												<label className="form-label">Username </label>
													<input
														type="text"
														className="form-control required-input required-tooltip"
														placeholder="Username" name="username" value={users.username} onChange={handelInput}
													/>
												</div>
											</div>


											<div className="col-md-3 col-sm-12 required-tooltip">   
												<div className="form-group"> 
												<label className="form-label">Email </label>
													<input
														type="text"
														className="form-control required-input required-tooltip"
														placeholder="Email" name="email" value={users.email} onChange={handelInput}
													/>
												</div>
											</div>

											<div className="col-md-3 col-sm-12 required-tooltip">   
												<div className="form-group"> 
												<label className="form-label">Contact Number </label>
													<input
														type="text"
														className="form-control required-input required-tooltip"
														placeholder="Contact Number" name="contact_no" value={users.contact_no} onChange={handelInput}  maxlength="10" 
													/>
												</div>
											</div>

											<div className="col-md-3 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">Gender </label>
													<select className="form-control show-tick required-input required-tooltip" name="gender" value={users.gender} onChange={handelInput}>
														<option value="">Select Gender</option>
														<option value="Male">Male</option>
														<option value="FeMale">Female</option>
														
													</select>
												</div>
											</div>

											<div className="col-md-3 col-sm-12 required-tooltip">
			<div className="form-group">
			<label className="form-label">Floor </label>

			<select className="form-control show-tick required-input required-tooltip" name="floor_id" value={users.floor_id} onChange={handelInput}>
			<option>Select Floor</option>
				{floorval.map(option => (
				<option key={option.floor_id} value={option.floor_id}>
				{option.floor_name}
				</option>
				))}
        </select>
		</div>
       </div>


	   <div className="col-md-3 col-sm-12 required-tooltip">
			<div className="form-group">
			<label className="form-label">Department </label>

			<select className="form-control show-tick required-input required-tooltip" name="department" value={department} onChange={handleFirstDropdownChange}>
			<option>Select Department</option>
				{dataval.map(option => (
				<option key={option.department_id} value={option.department_id}>
				{option.department_name}
				</option>
				))}
        </select>
				{/* <select className="form-control show-tick" name="department" value={user.department} onChange={handleFirstDropdownChange}>
					<option>Select Department</option>

					{dataval.map(option => (
					<option key={option.department_id} value={option.department_id}>
					{option.department_name}
					</option>
					))}
				</select> */}
			</div>
		</div>

		<div className="col-md-3 col-sm-12 required-tooltip">
			<div className="form-group">
			<label className="form-label">Designation </label>
			<select className="form-control show-tick required-input required-tooltip"
          value={designation} name="designation"
          onChange={handleSecondDropdownChange}
          disabled={designationDropdownOptions.length === 0}
        >
          <option value="">Select Designation</option>
          {designationDropdownOptions.map((option) => (
            <option key={option.designation_id} value={option.designation_id}>
              {option.designation_name}
            </option>
          ))}
        </select>
			</div>
		</div>


		<div className="col-md-3 col-sm-12 required-tooltip">
	<label className="form-label">Date Of Joining </label>
		<div className="form-group">

		<input type="date" className="form-control" name="date_of_joining" value={users.date_of_joining}
								onChange={handelInput} placeholder="Select Date of Joining" />
		</div>
	</div>


	<div className="col-md-3 col-sm-12 required-tooltip">
			<label className="form-label">Date Of Birth </label>
			<div className="form-group">

			<input type="date" className="form-control required-input required-tooltip" name="date_of_birth" value={users.date_of_birth}
								onChange={handelInput} placeholder="Select Date of Birth" />
			</div>
	</div>

 

	<div className="col-md-3 col-sm-12">
	<label className="form-label">Pan no </label>
        <div class="form-group">
            <input class="form-control" placeholder="PAN Number" name="pan_no" type="text" value={users.pan_no} onChange={handelInput} />
        </div>
    </div>

	<div className="col-md-3 col-sm-12">
	<label className="form-label">Adhaar No</label>
        <div class="form-group">
            <input class="form-control " placeholder="Adhaar No" name="adhar_no" type="text" value={adhar_no} onChange={handelNumber2}/>
        </div>
    </div>


	<div className="col-md-3 col-sm-12">
	<label className="form-label">UAN No</label>
        <div class="form-group">
            <input class="form-control" placeholder="UAN No" name="uan_no" type="text" value={users.uan_no} onChange={handelInput}/>
        </div>
    </div>

	<div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">Marital Status </label>

			<select className="form-control show-tick" name="marital_status" value={users.marital_status} onChange={handelInput}>
			<option value="">Marital Status</option>
			<option value="Single">Single</option>
                      <option value="Married">Married</option>
                      <option value="Widowed">Widow</option>
                      <option value="Divorced or Separated">Divorced or Separated</option>
        </select>
		</div>
       </div>


   <div className="col-md-3 col-sm-12">
		<label className="form-label">Prev PF No </label>
        <div class="form-group">
            <input class="form-control" placeholder="Previous PF No" name="pre_pfno" type="text" value={users.pre_pfno} onChange={handelInput} />
        </div>
    </div>


	<div className="col-md-3 col-sm-12">
		<label className="form-label">ESI No</label>
        <div class="form-group">
            <input class="form-control" placeholder="ESI No" name="esi_no" type="text" value={users.esi_no} onChange={handelInput} />
        </div>
    </div>


	<div className="col-md-3 col-sm-12">
		<label className="form-label">Qualification</label>
        <div class="form-group">
            <input class="form-control" placeholder="Qualification" name="qualification" type="text" value={users.qualification} onChange={handelInput} />
        </div>
    </div>

	  <div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">Login Status </label>

			<select className="form-control show-tick" name="is_active" value={users.is_active} onChange={handelInput}>
			<option value="0">InActive</option>
			<option value="1">Active</option>
            
        </select>
		</div>
       </div>


	      {Number(users.is_active) === 0 && (
  <>
	<div className="col-md-3 col-sm-12 required-tooltip">
			<label className="form-label">Date Of Leaving </label>
			<div className="form-group">

			<input type="date" className="form-control required-input required-tooltip" name="date_of_leaving" value={users.date_of_leaving}
								onChange={handelInput} placeholder="Select Date of Leaving" />
			</div>
	</div>

	<div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">Reason Status </label>

			<select className="form-control show-tick" name="reason_status" value={users.reason_status} onChange={handelInput}>
			<option value="Terminate">Terminate</option>
			<option value="Abscond">Abscond</option>
			<option value="Resigned">Resigned</option>
            
        </select>
		</div>
       </div>

	<div className="col-md-12 col-sm-12 required-tooltip">
		<div className="form-group">
		<label className="form-label">Reason For Leaving </label>

		<textarea className='required-input required-tooltip'
			id="textarea"
			name="inactive_reason"
			value={users.inactive_reason} // Bind the value to state
			onChange={handelInput} // Update state on change
			placeholder=""
			rows="4" // Number of rows (optional)
			cols="68" // Number of columns (optional)
			></textarea>
									
		</div>
	</div>
   </>
   )}


	   <div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">Experience </label>
			<input class="form-control" placeholder="" name="experience" type="text" value={users.experience} onChange={handelInput} />
		</div>
       </div>


	   <div className="col-md-3 col-sm-12 required-tooltip">
			<div className="form-group">
			<label className="form-label">Notice Period </label>

			<select className="form-control show-tick required-input required-tooltip" name="notice_period" value={users.notice_period} onChange={handelInput}>
			<option value="">Select Notice Period</option>
			<option value="1">1</option>
			<option value="15">15</option>
			<option value="30">30</option>
			<option value="60">60</option>
            
        </select>
		</div>
       </div>

	   <div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">TDS</label>

			<select className="form-control show-tick" name="tds_applicable" value={users.tds_applicable} onChange={handelInput}>
			<option value="">Select Tds</option>
			<option value="1">Applicable</option>
			<option value="0">Not Applicable</option>
	
        </select>
		</div>
       </div>


	   <div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">PF Status</label>

			<select className="form-control show-tick" name="pf_status" value={users.pf_status} onChange={handelInput}>
			<option value="">Select PF Status</option>
			<option value="1">Under PF</option>
			<option value="0">Not Applicable</option>
	
        </select>
		</div>
       </div>


	   <div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">Notice Period Status</label>

			<select className="form-control show-tick" name="notice_period_status" value={users.notice_period_status} onChange={handelInput}>
			<option value="">Select Notice Period Status</option>
			<option value="1">Under Notice Period</option>
			<option value="0">Not Applicable</option>
	
        </select>
		</div>
       </div>


	   <div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">Flat Status</label>

			<select className="form-control show-tick" name="flat_status" value={users.flat_status} onChange={handelInput}>
			<option value="">Select Flat Status</option>
			<option value="1">Under Flat</option>
			<option value="0">Not Applicable</option>
	
        </select>
		</div>
       </div>

	   <div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">Current Salary </label>
			<input class="form-control" placeholder="" name="current_salary" type="text" value={current_salary} onChange={handelNumber} />
		</div>
       </div>


	   <div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">Expected Salary </label>
			<input class="form-control" placeholder="" name="expected_salary" type="text" value={expected_salary} onChange={handelNumber1} />
		</div>
       </div>


	   <div className="col-md-3 col-sm-12 required-tooltip">
			<div className="form-group">
			<label className="form-label">Role </label>

			<select className="form-control show-tick required-input required-tooltip" name="user_role_id" value={users.user_role_id} onChange={handelInput}>
			<option value="">Select Role</option>
				{roleval.map(option => (
				<option key={option.role_id} value={option.role_id}>
				{option.role_name}
				</option>
				))}
        </select>
		</div>
       </div>


	    <div className="col-md-3 col-sm-12 required-tooltip">
			<div className="form-group">
			<label className="form-label">Employee Shift </label>

			<select className="form-control show-tick required-input required-tooltip" name="employee_shift" value={employee_shift} onChange={handelShiftEmployee}>
			<option value="">Select Employee Shift</option>
			<option value="1">Normal Shift</option>
            <option value="2">Nearby Shift</option>
        </select>
		</div>
       </div>


	   {employee_shift==2 && (
		
		<div className="col-md-3 col-sm-12 required-tooltip">
			 <div className="form-group">
			 <label className="form-label">Contractor </label>
 
			 <select className="form-control show-tick required-input required-tooltip" name="contractor" value={contractor} onChange={handleContractorDropdownChange} >
			 <option value="">Select Contractor</option>
				 {contractordata.map(option => (
				 <option key={option.id} value={option.id}>
				 {option.contractor_name}
				 </option>
				 ))}
		 </select>
				 
			 </div>
		 </div>
		)}



	   {employee_shift==2 && (
		<div className="col-md-3 col-sm-1 required-tooltip">   
			<div className="form-group">
			<label className="form-label">Contractor Type </label>
			<select className="form-control show-tick required-input required-tooltip"
          value={contractortype} name="contratortype"
          onChange={handleContractorTypeDropdownChange}
          disabled={contractotypeDropdownOptions.length === 0}
        >
          <option value="">Select Designation</option>
          {contractotypeDropdownOptions.map((option) => (
            <option key={option.contractor_type_id} value={option.contractor_type_id}>
              {option.role_name}
            </option>
          ))}
        </select>
			</div>
		</div>

)}


	   {/* recorded once at joining — read only after it has been saved */}
	   <div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">Mother Tongue </label>
			<input class="form-control" placeholder="Mother Tongue" name="mother_tongue" type="text" value={users.mother_tongue || ''} readOnly={motherTongueLocked} onChange={handelInput} />
		</div>
       </div>

	   {/* password is hidden on this page - change it from the Change Password tab
	   <div className="col-md-3 col-sm-12">
			<div className="form-group">
			<label className="form-label">Password </label>
			<input class="form-control" placeholder="Password" name="password_text" type="text" value={users.password_text || ''} readOnly />
		</div>
       </div>
	   */}


	   {/* the appointment order is addressed from this, so it spans the row */}
	   <div className="col-md-12 col-sm-12">
			<div className="form-group">
			<label className="form-label">Address </label>
			<textarea class="form-control" placeholder="Address" name="address" rows="3" value={users.address || ''} onChange={handelInput} />
		</div>
       </div>



											</div>


											{/* <div className="row mt-3">
  <div className="col-md-12">
    <button className="btn btn-primary btn-block">Save</button>
  </div>
</div> */}

											<div className="d-flex flex-wrap align-items-center mt-3" style={{ gap: "10px" }}>
  <button className="btn btn-primary text-nowrap px-4">
    Save
  </button>

  {net_take && Number(net_take) > 0 && (
    <button
      type="button"
      className="btn btn-primary text-nowrap px-4"
      onClick={generateOfferLetter}
    >
      Offer Letter
    </button>
  )}

  {net_take && Number(net_take) > 0 && (
    <button
      type="button"
      className="btn btn-primary text-nowrap px-4"
      onClick={generateAppointmentOrder}
    >
      Appointment Order
    </button>
  )}

  {users.date_of_leaving && (
    <button
      type="button"
      className="btn btn-primary text-nowrap px-4"
      onClick={generateExperienceCertificate}
    >
      Experience Certificate
    </button>
  )}

  {Number(exitDetail?.hr_status) === 2 && (
    <button
      type="button"
      className="btn btn-primary text-nowrap px-4"
      onClick={generateRelievingLetter}
    >
      Relieving Letter
    </button>
  )}


</div>




											</form>

											</div>

																</div>
															</div>
														</div>
													</div>
													</div>
													</div>
													</div>

                                    </Accordion>

									<Accordion title="Manage Approval">

									<div className="container-fluid">
														<div className="row clearfix">
															<div className="col-md-12">
																<div className="card">


									 <div className="card-body">
									

										<form onSubmit={handleApprovalSubmit}>
											<div class="row">
									{/* optional - an employee can report straight to the hod */}
									<div className="col-md-3 col-sm-12">
											<div className="form-group">
											<label className="form-label">Incharge </label>

											<Select
												name="inchargeval"

												options={approvalEmployeeOptions}
												value={approvalEmployeeOptions.find(opt => String(opt.value) === String(inchargeval)) || null}
												onChange={handleapprovalinchargeChange}
												styles={approvalSelectStyles}
												menuPortalTarget={document.body}

												className="basic-single"
												classNamePrefix="select"
												isClearable
												isSearchable
												placeholder="None"

											/>
										</div>
									</div>

									<div className="col-md-3 col-sm-12 required-tooltip">
											<div className="form-group">
											<label className="form-label">Hod </label>

											<Select
												name="hodval"

												classNames={{ control: () => "required-select" }}
												classNamePrefix="react-select"
												options={approvalEmployeeOptions}
												value={approvalEmployeeOptions.find(opt => opt.value === String(hodval ?? "")) || null}
												onChange={handleapprovalhodChange}
												isSearchable={true}
												placeholder="Search Hod"
												styles={approvalSelectStyles}
												menuPortalTarget={document.body}

												className="basic-single"
												classNamePrefix="select"
												options={approvalEmployeeOptions}
												value={approvalEmployeeOptions.find(opt => String(opt.value) === String(hodval)) || null}
												onChange={handleapprovalhodChange}
												isClearable
												isSearchable
												placeholder="None"

											/>
										</div>
									</div>

									</div>

									<div class="row">

											<div className="form-footer">
												<button className="btn btn-primary btn-block">Save</button>
											</div>
											</div>

									</form>
									</div>
									</div>
									</div>
									</div>
									</div>

                                    </Accordion>


									<Accordion title="Salary Info">

									<div className="container-fluid">
														<div className="row clearfix">
															<div className="col-md-12">
																<div className="card">


									 <div className="card-body">
										{/* <form onSubmit={handleapprovalSubmit}> */}

										<form onSubmit={handleSalarySubmit}>
											<div class="row">
										<div className="col-md-4 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">Gross Salary </label>

												<input class="form-control required-input required-tooltip" placeholder="Gross Salary" name="gross_salary" type="number" value={gross_salary} readOnly={isReadonly} onChange={(e)=>{handelsalaryInput(e.target.value,convy,wash_allow,insurance,hostel_fee);setGross(e.target.value)}} />
											</div>
									    </div>


										<div className="col-md-4 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">Convyance </label>

												<input class="form-control required-input required-tooltip" placeholder="Convyance" name="convy" type="text" value={convy} readOnly={isReadonly} onChange={(e)=>{handelsalaryInput(gross_salary,e.target.value,wash_allow,insurance,hostel_fee);setConvy(e.target.value)}}  disabled={gross_salary.length === 0}/>
											</div>
									    </div>

										<div className="col-md-4 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">Wash Allowance </label>

												<input class="form-control required-input required-tooltip" placeholder="Wash Allowance" readOnly={isReadonly} name="wash_allow" type="text" value={wash_allow} onChange={(e)=>{handelsalaryInput(gross_salary,convy,e.target.value,insurance,hostel_fee);setWashAllow(e.target.value)}} disabled={gross_salary.length === 0} />
											</div>
									    </div>


										<div className="col-md-4 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">Basic Salary</label>

												<input class="form-control required-input required-tooltip" placeholder="" name="basic_salary" type="text" value={basic_salary}  onChange={handelsalaryInput} disabled/>
											</div>
									    </div>

									

										<div className="col-md-4 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">HRA</label>

												<input class="form-control required-input required-tooltip" placeholder="" name="hra" type="text" value={hra} onChange={handelsalaryInput} disabled/>
											</div>
									    </div>

										<div className="col-md-4 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">Special Conveyance</label>

												<input class="form-control required-input required-tooltip" placeholder="" name="special_convyance" type="text" value={special_convyance} onChange={handelsalaryInput} disabled/>
											</div>
									    </div>


										<div className="col-md-4 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">PF Emloyer</label>

												<input class="form-control required-input required-tooltip" placeholder="" name="pf_employer" type="text" value={pf_employer} onChange={handelsalaryInput} disabled/>
											</div>
									    </div>


										<div className="col-md-4 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">ESI Employer</label>

												<input class="form-control required-input required-tooltip" placeholder="" name="esi_employer" type="text" value={esi_employer} onChange={handelsalaryInput} disabled/>
											</div>
									    </div>

										<div className="col-md-4 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">Insurance</label>

												<input class="form-control required-input required-tooltip" placeholder="" name="insurance" type="text" readOnly={isReadonly} value={insurance} onChange={(e)=>{handelsalaryInput(gross_salary,convy,wash_allow,e.target.value,hostel_fee);setInsurance(e.target.value)}}  disabled={gross_salary.length === 0}/>
											</div>
									    </div>

										<div className="col-md-4 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">PF Emloyee</label>

												<input class="form-control required-input required-tooltip" placeholder="" name="pf_employee" type="text" value={pf_employee} onChange={handelsalaryInput} disabled/>
											</div>
									    </div>

										<div className="col-md-4 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">ESI Emloyee</label>

												<input class="form-control required-input required-tooltip" placeholder="" name="esi_employee" type="text" value={esi_employee} onChange={handelsalaryInput} disabled/>
											</div>
									    </div>

										<div className="col-md-4 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">Profession Tax</label>

												<input class="form-control required-input required-tooltip" placeholder="" name="pt" type="text" value={pt} onChange={handelsalaryInput} disabled/>
											</div>
									    </div>

										<div className="col-md-3 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">Hostel Fee</label>

												<input class="form-control required-input required-tooltip" placeholder="" name="pt" readOnly={isReadonly} type="text" value={hostel_fee} onChange={(e)=>{handelsalaryInput(gross_salary,convy,wash_allow,insurance,e.target.value);setHostelFee(e.target.value)}}  disabled={gross_salary.length === 0}/>
											</div>
									    </div>

										<div className="col-md-3 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">TDS</label>

												<input class="form-control required-input required-tooltip" placeholder="" name="tds" type="text" value={tds} onChange={handelsalaryInput} disabled/>
											</div>
									    </div>

										<div className="col-md-3 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">CTC</label>

												<input class="form-control required-input required-tooltip" placeholder="" name="ctc" type="text" value={ctc} onChange={handelsalaryInput} disabled/>
											</div>
									    </div>


										<div className="col-md-3 col-sm-12 required-tooltip">
												<div className="form-group">
												<label className="form-label">Take Home</label>

												<input class="form-control required-input required-tooltip" placeholder="" name="net_take" type="text" value={net_take} onChange={handelsalaryInput} disabled/>
											</div>
									    </div>


										<div className="col-md-3 col-sm-12">
												<div className="form-group">
												<label className="form-label">UAN No</label>

												<input class="form-control" placeholder="" name="uan_no" type="text" value={uan_no} onChange={(e)=>setUanNo(e.target.value)}/>
											</div>
									    </div>

										<div className="col-md-3 col-sm-12">
												<div className="form-group">
												<label className="form-label">Bank Name</label>

												<input class="form-control" placeholder="BANK NAME" name="bank_name" type="text" value={bank_name} onChange={(e)=>setBankName(e.target.value)}/>
											</div>
									    </div>

										<div className="col-md-3 col-sm-12">
												<div className="form-group">
												<label className="form-label">Account No</label>

												<input class="form-control" placeholder="Account No" name="account_no" type="text" value={account_no} onChange={(e)=>setAccountNo(e.target.value)}/>
											</div>
									    </div>

										<div className="col-md-3 col-sm-12">
												<div className="form-group">
												<label className="form-label">Branch Name</label>

												<input class="form-control" placeholder="BRANCH NAME" name="branch_name" type="text" value={branch_name} onChange={(e)=>setBranchName(e.target.value)}/>
											</div>
									    </div>

										<div className="col-md-3 col-sm-12">
												<div className="form-group">
												<label className="form-label">Ifsc No</label>

												<input class="form-control" placeholder="IFSC NO" name="ifsc_no" type="text" value={ifsc_no} onChange={(e)=>setIfscNo(e.target.value)}/>
											</div>
									    </div>


										<div className="col-md-3 col-sm-12">
												<div className="form-group">
												<label className="form-label">PF No</label>

												<input class="form-control" placeholder="" name="pf_no" type="text" value={pf_no} onChange={(e)=>setPfNo(e.target.value)}/>
											</div>
									    </div>

										<div className="col-md-3 col-sm-12">
												<div className="form-group">
												<label className="form-label">ESI No</label>

												<input class="form-control" placeholder="" name="esi_no" type="text" value={esi_no} onChange={(e)=>setEsiNo(e.target.value)}/>
											</div>
									    </div>

									

									</div>

									

									<div class="row">

											<div className="form-footer">

											
												<button className="btn btn-primary btn-block">Save</button>
											</div>
											</div>

									</form>
									</div>
									</div>
									</div>
									</div>
									</div>

                                    </Accordion>


									<Accordion title="Change Password">

									<div className="container-fluid">
														<div className="row clearfix">
															<div className="col-md-12">
																<div className="card">


									<div className="card-body">
										{/* <form onSubmit={handleapprovalSubmit}> */}

										<form onSubmit={handleChangePaswordSubmit}>
											<div class="row">
									<div className="col-md-3 col-sm-12 required-tooltip">
											<div className="form-group">
											<label className="form-label">Password </label>

											<input class="form-control required-input required-tooltip" placeholder="" name="newpassword" type="text" value={newpassword} onChange={handleNewPasswordChange}/>
										</div>
									</div>

									<div className="col-md-3 col-sm-12 required-tooltip">
											<div className="form-group">
											<label className="form-label">Confirm Passord </label>

											<input class="form-control required-input required-tooltip" placeholder="" name="confirmnewpassword" type="text" value={confirmnewpassword} onChange={handleConfirmNewPasswordChange}/>
										</div>
									</div>

									</div>

									<div class="row">

											<div className="form-footer">
												<button className="btn btn-primary btn-block">Save</button>
											</div>
											</div>

									</form>
									</div>
									</div>
									</div>
									</div>
									</div>

</Accordion>


										<Accordion title="Profile Picture">

										<div className="container-fluid">
															<div className="row clearfix">
																<div className="col-md-12">
																	<div className="card">


										<div className="card-body">
											

											<form onSubmit={handleProfileSubmit}>
												<div class="row">
										<div className="col-md-3 col-sm-12">
												<div className="form-group">
												<label className="form-label">Browse <span className="form-required">*</span> </label>
												
												<input type="file" accept="image/*" onChange={handleImageChange} className="block w-full" />
        
												{/* {preview && <img src={preview} alt="Preview" className="h-40 w-40 object-cover mt-2" />} */}
												
												{fetchprofile!='' && <img src={imagepath} alt="Preview" className="h-40 w-40 object-cover mt-2" />}
												
											</div>
										</div>

										

										</div>

										<div class="row">

												<div className="form-footer">
													<button className="btn btn-primary btn-block">Save</button>
												</div>
												</div>

										</form>
										</div>
										</div>
										</div>
										</div>
										</div>

										</Accordion>


										<Accordion title="Recruitment Details">

										<RecruitmentDetails />

										</Accordion>


										<Accordion title="Employee Verification">

										<EmpVerification />

										</Accordion>

										<Accordion title="Training & Accomodation">

										<TraingingAccomodation />

										</Accordion>


										


										<Accordion title="Qualification">

										<div className="container-fluid">
															<div className="row clearfix">
																<div className="col-md-12">
																	<div className="card">


										<div className="card-body">
											

											<form onSubmit={handleQualifcationSubmit}>
												<div class="row">
										
												<div className="col-md-6 col-sm-12 required-tooltip">   
												<div className="form-group"> 
												<label className="form-label">School/University </label>
													<input
														type="text"
														className="form-control required-input required-tooltip"
														placeholder="School/University" name="qualification_name" value={edu.qualification_name} onChange={handelEducationInput}
													/>
												</div>
											</div>

											<div className="col-md-6 col-sm-12 required-tooltip">
											<div className="form-group">
											<label className="form-label">Education Level </label>

											<select className="form-control show-tick required-input required-tooltip" name="educationlevel" value={edu.educationlevel} onChange={handelEducationInput}>
												<option value="">Select Education Lervel</option>
												{alleducationlevel.map(option => (
												<option key={option.education_level_id} value={option.education_level_id}>
												{option.name} 
												</option>
												))} 
										</select>
										</div>
									</div>

									<div className="col-md-6 col-sm-12 required-tooltip">
									<label className="form-label">From Year </label>
										<div className="form-group">

										<input type="date" className="form-control required-input required-tooltip" name="from_year" value={edu.from_year}
																onChange={handelEducationInput} placeholder="from" />
										</div>
									</div>

									<div className="col-md-6 col-sm-12 required-tooltip">
									
										<div className="form-group">
										<label className="form-label">To Year </label>
										<input type="date" className="form-control required-input required-tooltip" name="to_year" value={edu.to_year}
																onChange={handelEducationInput} placeholder="to" />
										</div>
									</div>

									<div className="col-md-6 col-sm-12 required-tooltip">
											<div className="form-group">
											<label className="form-label">Language </label>

											<select className="form-control show-tick required-input required-tooltip" name="language" value={edu.language} onChange={handelEducationInput}>
											<option value="">Select Language</option>
												{allqualificationlanguage.map(option => (
												<option key={option.language_id} value={option.language_id}>
												{option.language_name} 
												</option>
												))} 
										</select>
										</div>
									</div>


									<div className="col-md-6 col-sm-12">
											<div className="form-group">
											<label className="form-label">Professional Courses (if any) 
											</label>

											<select className="form-control show-tick" name="skill" value={edu.skill} onChange={handelEducationInput}>
												<option value="">Professional Courses (if any) </option>
												{allqualificationskill.map(option => (
												<option key={option.skill_id} value={option.skill_id}>
												{option.skill_name} 
												</option>
												))} 
										</select>
										</div>
									</div>


									<div className="col-md-12 col-sm-12">
										<div className="form-group">
										<label className="form-label">Description</label>

										<textarea
										id="textarea"
										name="description"
										value={edu.description} // Bind the value to state
										onChange={handelEducationInput} // Update state on change
										placeholder="Description"
										rows="4" // Number of rows (optional)
										cols="68" // Number of columns (optional)
									></textarea>
									
									</div>
								</div>


										

										</div>

										<div class="row">

												<div className="form-footer">
													<button className="btn btn-primary btn-block">Save</button>
												</div>
												</div>

										</form>
										</div>
										</div>
										</div>
										</div>
										</div>

										</Accordion>



										<Accordion title="Work Experience">


											

										<div className="container-fluid">
															<div className="row clearfix">
																<div className="col-md-12">
																	<div className="card">


										<div className="card-body">
											

											<form onSubmit={handleWorkingExpSubmit}>
												<div class="row">
										
												<div className="col-md-6 col-sm-12 required-tooltip">   
												<div className="form-group"> 
												<label className="form-label">Company Name </label>
													<input
														type="text"
														className="form-control required-input required-tooltip"
														placeholder="Company Name" name="company_name" value={work.company_name} onChange={handelWorkExpInput}
													/>
												</div>
											</div>

											<div className="col-md-6 col-sm-12 required-tooltip">   
												<div className="form-group"> 
												<label className="form-label">Post </label>
													<input
														type="text"
														className="form-control required-input required-tooltip"
														placeholder="Post" name="post" value={work.post} onChange={handelWorkExpInput}
													/>
												</div>
											</div>

											
									<div className="col-md-6 col-sm-12 required-tooltip">
									<label className="form-label">From Date </label>
										<div className="form-group">

										<input type="date" className="form-control required-input required-tooltip" name="from_date" value={work.from_date}
																onChange={handelWorkExpInput} placeholder="" />
										</div>
									</div>

									<div className="col-md-6 col-sm-12 required-tooltip">
									
										<div className="form-group">
										<label className="form-label">To Date </label>
										<input type="date" className="form-control required-input required-tooltip" name="to_date" value={work.to_date}
																onChange={handelWorkExpInput} placeholder="" />
										</div>
									</div>

									


									<div className="col-md-12 col-sm-12">
										<div className="form-group">
										<label className="form-label">Description</label>

										<textarea
										id="textarea"
										name="description"
										value={work.description} // Bind the value to state
										onChange={handelWorkExpInput} // Update state on change
										placeholder="Description"
										rows="4" // Number of rows (optional)
										cols="68" // Number of columns (optional)
									></textarea>
									
									</div>
								</div>


										

										</div>

										<div class="row">

												<div className="form-footer">
													<button className="btn btn-primary btn-block">Save</button>
												</div>
												</div>

										</form>
										</div>
										</div>
										</div>
										</div>
										</div>


												


										<div className="card-body">
											<div className="table-responsive">
												<table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
													<thead>
														<tr>
															<th>Action</th>
															<th>Company Name</th>
															<th>Post</th>
															<th>From Date</th>
															<th>To Date</th>
														</tr>
													</thead>
													<tbody>



														{
															data.map((exp, index) => {

																return <tr key={index}>
																	<td className="d-flex">
																	<button
																			type="button" onClick={() =>{ handleUpdate(exp.work_experience_id);setWork(emptyWork)}}
																			className="btn btn-icon btn-sm"
																			title="Edit" data-toggle="modal"
																			data-target="#exampleEditModal"
																		>
																			<i className="fa fa-edit" />
																		</button>
																	</td>
																	<td>
																		<span>{exp.company_name}</span>
																	</td>
																	<td>
																		<span>{exp.post}</span>
																	</td>
																	<td>
																		<span>{exp.from_date}</span>
																	</td>

																	<td>
																		<span>{exp.to_date}</span>
																	</td>

																	
																</tr>


															})
														}

													</tbody>
												</table>
											</div>



											
										</div>

										</Accordion>





										<Accordion title="Document">


											

										<div className="container-fluid">
															<div className="row clearfix">
																<div className="col-md-12">
																	<div className="card">


										<div className="card-body">
											

											<form onSubmit={handleDocumentUploadSubmit}>
												<div class="row">
										
												<div className="col-md-6 col-sm-12 required-tooltip">   
												<div className="form-group"> 
												<label className="form-label">Document Type </label>
												<select className="form-control show-tick required-input required-tooltip" name="document_type" value={document.document_type} onChange={handelDocumentUploadInput}>
											<option value="">Select Document Type</option>
												{alldocumenttypelevel.map(option => (
												<option key={option.document_type_id} value={option.document_type_id}>
												{option.document_type} 
												</option>
												))} 
										</select>
												</div>
											</div>

											

											
									<div className="col-md-6 col-sm-12 required-tooltip">
									<label className="form-label">Date Of Expiry </label>
										<div className="form-group">

										<input type="date" className="form-control required-input required-tooltip" name="date_of_expiry" value={document.date_of_expiry}
																onChange={handelDocumentUploadInput} placeholder="" />
										</div>
									</div>



									<div className="col-md-6 col-sm-12 required-tooltip">   
												<div className="form-group"> 
												<label className="form-label">Document Title </label>
													<input
														type="text"
														className="form-control required-input required-tooltip"
														placeholder="Document Title" name="title" value={document.title} onChange={handelDocumentUploadInput}
													/>
												</div>
											</div>

									<div className="col-md-6 col-sm-12">
									
										<div className="form-group">
										<label className="form-label">Dcoument File </label>
										<input type="file" accept="image/*" onChange={handleDocumentChange} className="block w-full" />
										<span style={{fontSize:'10px',fontWeight:'900'}}>Upload files only: png, jpg, jpeg, gif, txt, pdf, xls, xlsx, doc, docx</span>
										</div>
									</div>

									


									<div className="col-md-12 col-sm-12">
										<div className="form-group">
										<label className="form-label">Description</label>

										<textarea
										id="textarea"
										name="description"
										value={document.description} // Bind the value to state
										onChange={handelDocumentUploadInput} // Update state on change
										placeholder="Description"
										rows="4" // Number of rows (optional)
										cols="68" // Number of columns (optional)
									></textarea>
									
									</div>
								</div>


										

										</div>

										<div class="row">

												<div className="form-footer">
													<button className="btn btn-primary btn-block">Save</button>
												</div>
												</div>

										</form>
										</div>
										</div>
										</div>
										</div>
										</div>


												


										<div className="card-body">
											<div className="table-responsive">
												<table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
													<thead>
														<tr>
															<th>Action</th>
															<th>Document Type</th>
															<th>Document Title</th>
															<th>Date Of Expiry</th>
														</tr>
													</thead>
													<tbody>



														{
															docfetch.map((doc, index) => {

																let filepath=UPLOADS_BASE_URL+'/uploads/document/'+doc.document_file;

																return <tr key={index}>
																	<td className="d-flex">
																	<a
																		href={filepath}
																		download={filepath}
																	
																		>
																		<button type="button" className="btn btn-icon btn-sm" title="Print" data-toggle="tooltip" data-placement="top"><i className="icon-printer" /></button>
																		</a>
																	<button
																			type="button" onClick={() =>{ handleDocUpdate(doc.document_id);setWork(emptyWork)}}
																			className="btn btn-icon btn-sm"
																			title="Edit" data-toggle="modal"
																			data-target="#exampleEditDocumentModal"
																		>
																			<i className="fa fa-edit" />
																		</button>
																	</td>
																	<td>
																		<span>{doc.document_type}</span>
																	</td>
																	<td>
																		<span>{doc.title}</span>
																	</td>
																	<td>
																		<span>{doc.date_of_expiry}</span>
																	</td>

																	

																	
																</tr>


															})
														}

													</tbody>
												</table>
											</div>



											
										</div>

										</Accordion>



                                        {/* <span style={{width:'100px',float: 'right',margin: '10px 35px 15px 10px'}}
										type="button"
										
										onClick={()=>setToggle(!toggle)}
									>
										<i className="fa fa-angle-down mr-2" />
										
									</span> */}
                                    
                                            




										</div>
									</div>
								</div>

							</div>
						</div>
					</div>

				</div>
			</div>



			<div
				className="modal fade"
				id="exampleEditModal"
				tabIndex={-1}
				role="dialog"
				aria-labelledby="exampleModalLabel"
				aria-hidden="true"
			>
				<form onSubmit={handleEditWorkExpSubmit}>
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title" id="exampleModalLabel">
									Edit Work Experience
								</h5>
								<button type="button" className="close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">×</span>
								</button>
							</div>
							<div className="modal-body">
								<div className="row clearfix">
									<div className="col-md-12 col-sm-6">
										<div className="form-group">
										<label className="form-label">Company Name</label>
											<input type="text" className="form-control" name="company_name" value={work.company_name}
												onChange={handelWorkExpInput} placeholder="Company Name" />
										</div>
									</div>
									<div className="col-md-12 col-sm-6">
										<div className="form-group">
										<label className="form-label">Post </label>
											<input type="text" className="form-control" name="post" value={work.post}
												onChange={handelWorkExpInput} placeholder="Post" />
										</div>
									</div>
									

									<div className="col-md-12 col-sm-6">
										<div className="form-group">
										<label className="form-label">From Date </label>
										<input type="date" className="form-control" name="from_date" value={work.from_date}
																onChange={handelWorkExpInput} placeholder="" />
										</div>
									</div>

									<div className="col-md-12 col-sm-6">
										<div className="form-group">
										<label className="form-label">To Date </label>
										<input type="date" className="form-control" name="to_date" value={work.to_date}
																onChange={handelWorkExpInput} placeholder="" />
										</div>
									</div>


									<div className="col-md-12 col-sm-6">
										<div className="form-group">
										<label className="form-label">Experience</label>
										<textarea
										id="textarea"
										name="description"
										value={work.description} // Bind the value to state
										onChange={handelWorkExpInput} // Update state on change
										placeholder="Description"
										rows="4" // Number of rows (optional)
										cols="45" // Number of columns (optional)
									></textarea>
										</div>
									</div>

								</div>
							</div>
							<div className="modal-footer">

							<input type="hidden" className="form-control" name="id" value={work.work_experience_id}
																 />
								<button type="button" className="btn btn-secondary" data-dismiss="modal">
									Close
								</button>
								<button type="submit" className="btn btn-primary">
									Save changes
								</button>
							</div>
						</div>
					</div>

				</form>

			</div>



			<div
				className="modal fade"
				id="exampleEditDocumentModal"
				tabIndex={-1}
				role="dialog"
				aria-labelledby="exampleModalLabel"
				aria-hidden="true"
			>
				<form onSubmit={handleEditDocumentSubmit}>
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title" id="exampleModalLabel">
									Edit Document
								</h5>
								<button type="button" className="close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">×</span>
								</button>
							</div>
							<div className="modal-body">
								<div className="row clearfix">
									<div className="col-md-12 col-sm-6">
										<div className="form-group">
										<label className="form-label">Document Type</label>
										<select className="form-control show-tick" name="document_type" value={document.document_type} onChange={handelDocumentUploadInput}>
											<option value="">Select Document Type</option>
												{alldocumenttypelevel.map(option => (
												<option key={option.document_type_id} value={option.document_type_id}>
												{option.document_type} 
												</option>
												))} 
										</select>
										</div>
									</div>
									<div className="col-md-12 col-sm-6">
										<div className="form-group">
										<label className="form-label">Date Of Expiry </label>
										<input type="date" className="form-control" name="date_of_expiry" value={document.date_of_expiry}
																onChange={handelDocumentUploadInput} placeholder="" />
										</div>
									</div>
									

									<div className="col-md-12 col-sm-6">
										<div className="form-group">
										<label className="form-label">Document Title</label>
										<input
														type="text"
														className="form-control"
														placeholder="Document Title" name="title" value={document.title} onChange={handelDocumentUploadInput}
													/>
										</div>
									</div>

									<div className="col-md-12 col-sm-6">
										<div className="form-group">
										<label className="form-label">Dcoument File <span className="form-required">*</span> </label>
										<input type="file" accept="image/*" onChange={handleDocumentChange} className="block w-full" /><br />
										<span style={{fontSize:'10px',fontWeight:'900'}}>Upload files only: png, jpg, jpeg, gif, txt, pdf, xls, xlsx, doc, docx</span><br />
										<a href={filepath}><span style={{fontSize:'16px',fontWeight:'900',color:'red'}}>{document.document_file}</span></a>
										
										</div>
									</div>


									<div className="col-md-12 col-sm-6">
										<div className="form-group">
										<label className="form-label">Description</label>
										<textarea
										id="textarea"
										name="description"
										value={document.description} // Bind the value to state
										onChange={handelDocumentUploadInput} // Update state on change
										placeholder="Description"
										rows="4" // Number of rows (optional)
										cols="45" // Number of columns (optional)
									></textarea>
										</div>
									</div>

								</div>
							</div>
							<div className="modal-footer">

							<input type="hidden" className="form-control" name="id" value={document.document_id}
																 />
								<button type="button" className="btn btn-secondary" data-dismiss="modal">
									Close
								</button>
								<button type="submit" className="btn btn-primary">
									Save changes
								</button>
							</div>
						</div>
					</div>

				</form>

			</div>




		</>
	);
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(EmployeeDetailControl);